import React from 'react';
import type { FabricObject } from 'fabric';
import { PillSettings, PILL_SETTINGS_KEY, isPillTextbox } from '../pill';
import { SobreimpresoSettings, SOBREIMPRESO_SETTINGS_KEY, isSobreimpresoTextbox } from '../text';
import { AutoFitTextSettings, AUTO_FIT_TEXT_SETTINGS_KEY, isAutoFitTextbox } from '../auto-fit-text';
import { GroupSettings } from '../grouping';
import { VideoSettings, VIDEO_SETTINGS_KEY, isVideoImage } from '../media';

// One entry per custom component that needs its own settings panel.
// settings-panel.tsx consumes this — no edits there when adding a new component.

export type SettingsLayout = 'toolbar' | 'panel';

export type CustomComponentEntry = {
  key: string;
  isMatch: (obj: FabricObject) => boolean;
  Component: React.FC;
  layout: SettingsLayout;
};

export const CUSTOM_COMPONENT_REGISTRY: CustomComponentEntry[] = [
  {
    key: VIDEO_SETTINGS_KEY,
    isMatch: isVideoImage,
    Component: VideoSettings,
    layout: 'toolbar'
  },
  {
    key: SOBREIMPRESO_SETTINGS_KEY,
    isMatch: isSobreimpresoTextbox,
    Component: SobreimpresoSettings,
    layout: 'toolbar'
  },
  {
    key: PILL_SETTINGS_KEY,
    isMatch: isPillTextbox,
    Component: PillSettings,
    layout: 'panel'
  },
  {
    key: AUTO_FIT_TEXT_SETTINGS_KEY,
    isMatch: isAutoFitTextbox,
    Component: AutoFitTextSettings,
    layout: 'panel'
  },
  {
    key: 'group-collection',
    isMatch: obj => obj.type === 'group',
    Component: GroupSettings,
    layout: 'panel'
  }
];
